module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Falter im Schnee")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Novembersturm in wildem Wirbeltanze"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ntreibt Flocken übers Feld und durch die Tannen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nschneeschwere Wolken düster rings umspannen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndas Firmament mit grauem Nebelglanze.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich nehme Hut und Stab und warme Hülle"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund pfeife schreitend meinen flinken Hunden,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\num auszuwandern meine Ruhestunden"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nin weißumwehten Forstes Winterstille.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der Leithund schnobert ruhlos durch die\nStämme;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndas Wachtelhündchen trollt an meiner Seite."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nIch schicke die Gedanken in die Weite,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ntraumferne schreitend über Bergeskämme.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Zur Jugend ging ich und zum später Alter"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nauf ungesehner und geheimer Fährte;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nbis ich zurück zu jener Stätte kehrte,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwo am Wacholder saß erstarrt ein Falter.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich nahm ihn auf; und seine güldnen Schwingen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nleis schonend, legt' ich ihn in meine Hände,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwo seines Kerkers lebenswarme Wände"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nbegannen ihn mit Wonne zu durchdringen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Er lebte auf, und er begann zu regen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndas Schwingenpaar und suchte zu entweichen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nich aber schnell mein Zimmer zu erreichen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwo ich gedachte seiner treu zu pflegen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Doch vor der Pforte zeigt' ich meinem Weibe,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwas ich gefunden, öffnend meine Finger,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund schnell benutzt's der kleine Flügelschwinger"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nzu seiner Flucht mit neu gestärktem Leibe.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Er hebt sich, regt mit Kraft die güldnen\nFlügel"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nzu unsrem Staunen durch die grauen Lüfte,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nbefreit sich wähnend, spottend seiner Grüfte,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ngradweges taumelnd nach dem Grabeshügel.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page26",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" Nie war die Freiheit näher beim Verderben!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nNie war die Wonne näher bei dem Wehe!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nNie war der Frühling näher bei dem Schneee!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nNie war das Leben näher bei dem Sterben!")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und rufen hört' ich tausend Frühlingsgeister,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nindes der Sturm zerwühlte meine Locken,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nindes ich starrte in das Spiel der Flocken:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndu warst ein lässig-schlechter Kerkermeister.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2ea57d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0011.vue
// module id = 87
// module chunks = 0